import { Directive, Input, OnDestroy } from '@angular/core';
import { TitleService } from '../root/page-title.service';

@Directive({
  selector: '[lohiPageTitle]',
})
export class PageTitleDirective implements OnDestroy {
  @Input('lohiPageTitle') public set pageTitle(title: string) {
    this.titleService.setTitle(title);
  }

  constructor(private titleService: TitleService) {}

  public ngOnDestroy() {
    this.titleService.setTitle(null);
  }
}
